import React from 'react';

import MicroApp from '../../components/MicroApp';
import useServicesSettings from './use-services-settings';

export function NewCategory() {
  const { isLoading, settings } = useServicesSettings();

  if (isLoading) {
    return null;
  }

  return <MicroApp name="services/NewCategory" settings={settings} />;
}
